export default {
  components: {
  },
  props: ['assigneeInfo'],
  data() {
    return {
      userInfo: {}, // 受让方信息
      materialInfo: {}, // 受让材料信息
      legalImgList: [], // 法人单位的授权委托书
      otherImgList: []  // 其他材料
    };
  },
  watch: {
    assigneeInfo (info) {
      let that = this;
      if(info) {
        that.userInfo = info.userInfo;
        that.materialInfo = info.materialInfo;
        that.materialInfo.images.map(item => {
          // 法人单位授权委托书
          if(Number(item.bizType) === 14) {
            that.legalImgList.push(item.allPath);
          }
          // 其他材料
          if(Number(item.bizType) === 11) {
            that.legalImgList.push(item.allPath);
          }
        });
      }
    }
  },
  methods: {

  }
};
